import PageTitleComponent from "../../components/PageTitle";
import UpdatePassword from "../../components/Profile/UpdatePassword";

export default function PasswordUpdateScreen(){
return <div>
    <PageTitleComponent title="Password Update" />
    <UpdatePassword/>
</div>
}